<template>
  <base-slide-over ref="cardReaderEdit" title="Edit Card Reader" size="xl" style="z-index: 10000">
    <base-form ref="editReaderForm" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-model="isFormValid">
      <base-text-field class="tw-mt-3" label="Reader Name" v-model="label" required />
    </base-form>
    <inline-error id="card-reader-edit-error" :title="errorTitle" :message="errorMessage" :error="error" />
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" class="tw-w-auto tw-mr-3" @click="close()">
          Cancel
        </base-button>
        <base-button :loading="isLoading" :disabled="!isFormValid" class="tw-w-auto" @click="edit">
          Save
        </base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { mapActions } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessCardReaderEdit",
  components: { InlineError },
  data() {
    return {
      businessId: null,
      stripeReaderId: null,
      label: null,
      isLoading: false,
      isFormValid: true,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    ...mapActions("terminal", { terminalInit: "init" }),
    reset() {
      this.businessId = null;
      this.stripeReaderId = null;
      this.label = null;
      this.isLoading = false;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    show(businessId, stripeReaderId, label) {
      this.reset();

      this.businessId = businessId;
      this.stripeReaderId = stripeReaderId;
      this.label = label;

      this.$refs.cardReaderEdit.show();
    },
    close() {
      this.$refs.cardReaderEdit.hide();
    },
    edit() {
      if (!this.$refs.editReaderForm.validate()) return;

      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/cardreaders/${this.stripeReaderId}`, { label: this.label })
        .then(() => {
          this.terminalInit();
          this.close();
          this.$emit("edit");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Card Reader Edited", message: "Card Reader was edited successfully" });
        })
        .catch((err) => {
          this.errorTitle = `Failed to edit card reader`;
          this.errorMessage = err.message;
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
